export const newDesignLocalStorageKey = "useNewDesign";
